import { frontendURL } from '../../../../helper/URLHelper';

import ProductsIndex from './ProductsIndex.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/products'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_products_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_products_list',
          component: ProductsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
